// extracted by mini-css-extract-plugin
export default {"closeButton":"AddTaskOrNot_closeButton__xGz8M","buttonDiv":"AddTaskOrNot_buttonDiv__fIbtI"};